var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 19.1874H5.36667L15.9802 8.57389L14.926 7.51973L4.3125 18.1333V19.1874ZM19.0229 7.54368L15.9562 4.47702L16.9625 3.47077C17.234 3.19924 17.5694 3.06348 17.9687 3.06348C18.3681 3.06348 18.7035 3.19924 18.975 3.47077L20.0292 4.52493C20.3007 4.79646 20.4365 5.13188 20.4365 5.53118C20.4365 5.93049 20.3007 6.26591 20.0292 6.53744L19.0229 7.54368ZM18.0167 8.54993L5.94167 20.6249H2.875V17.5583L14.95 5.48327L18.0167 8.54993ZM15.4531 8.04681L14.926 7.51973L15.9802 8.57389L15.4531 8.04681Z",
    fill: "#5F6369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2cdd4c38171edbb4c34ff929caf9b214.svg";
export { ForwardRef as ReactComponent };